// import React, { useState, useContext, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FaSignOutAlt,
//   FaUsers,
//   FaEnvelope,
//   FaServer,
//   FaUserCircle,
//   FaChevronDown,
//   FaUserPlus,
//   FaChartBar,
//   FaTimes,
//   FaRocket,
//   FaCog,
//   FaShieldAlt,
//   FaMoneyBillAlt,
//   FaPause,
//   FaSlidersH,
//  FaFileInvoice,
//   FaUserShield
// } from "react-icons/fa";
// import { AuthContext } from "../context/AuthContext";

// const Sidebar = ({ isOpen, onToggle }) => {
//   const { logout } = useContext(AuthContext);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [openDropdowns, setOpenDropdowns] = useState({});
//   const [mode, setMode] = useState("lead"); // Default to lead mode

//   // Check URL and localStorage on component mount
//   useEffect(() => {
//     // Get saved mode from localStorage
//     const savedMode = localStorage.getItem("sidebarMode");
    
//     // Check if we're on an admin panel route
//     const isAdminRoute = location.pathname.startsWith("/control-panel") || 
//                          location.pathname === "/createAccount" ||
//                          location.pathname === "/viewAccount" ||
//                          location.pathname === "/balance";
    
//     // Check if we're on a lead/dashboard route
//     const isLeadRoute = location.pathname.startsWith("/dashboard") ||
//                         location.pathname.startsWith("/campaigns") ||
//                         location.pathname.startsWith("/dlt-configuration") ||
//                         location.pathname.startsWith("/userprofile") ||
//                         location.pathname.startsWith("/tasks") ||
//                         location.pathname.startsWith("/settings");
    
//     // Determine mode based on current route and saved preference
//     if (isAdminRoute) {
//       setMode("account");
//       localStorage.setItem("sidebarMode", "account");
//     } else if (isLeadRoute) {
//       setMode("lead");
//       localStorage.setItem("sidebarMode", "lead");
//     } else if (savedMode) {
//       // Use saved mode if route doesn't clearly indicate
//       setMode(savedMode);
//     }
    
//     // Automatically open dropdowns based on current route
//     const updateDropdownsFromRoute = () => {
//       const newOpenDropdowns = {};
      
//       // Check if current route matches any sub-item
//       if (location.pathname.startsWith("/sendsingle") || 
//           location.pathname.startsWith("/sendbulk") || 
//           location.pathname.startsWith("/suspended-campaign")) {
//         newOpenDropdowns["campaigns"] = true;
//       }
      
//       if (location.pathname.startsWith("/senders") || 
//           location.pathname.startsWith("/templates")) {
//         newOpenDropdowns["dlt-configuration"] = true;
//       }
      
//       setOpenDropdowns(newOpenDropdowns);
//     };
    
//     updateDropdownsFromRoute();
//   }, [location.pathname]);

//   // Update mode when navigating between different sections
//   useEffect(() => {
//     // Listen for route changes to update mode
//     const handleRouteChange = () => {
//       if (location.pathname.startsWith("/control-panel") || 
//           location.pathname === "/createAccount" ||
//           location.pathname === "/viewAccount" ||
//           location.pathname === "/balance") {
//         setMode("account");
//         localStorage.setItem("sidebarMode", "account");
//       } else if (location.pathname.startsWith("/dashboard") ||
//                  location.pathname.startsWith("/campaigns") ||
//                  location.pathname.startsWith("/dlt-configuration") ||
//                  location.pathname.startsWith("/userprofile") ||
//                  location.pathname.startsWith("/tasks") ||
//                  location.pathname.startsWith("/settings")) {
//         setMode("lead");
//         localStorage.setItem("sidebarMode", "lead");
//       }
//     };
    
//     handleRouteChange();
//   }, [location.pathname]);

//   const closeSidebar = () => {
//     if (window.innerWidth < 1024 && onToggle) {
//       onToggle(false);
//     }
//   };

//   const toggleDropdown = (menuKey) => {
//     setOpenDropdowns((prev) => {
//       // Create new state where only the clicked menu is open
//       const newState = {};
      
//       // Close all other dropdowns first
//       Object.keys(prev).forEach(key => {
//         newState[key] = false;
//       });
      
//       // If the clicked dropdown was closed, open it. If it was open, keep it closed.
//       // This creates the toggle behavior while ensuring only one dropdown is open at a time
//       newState[menuKey] = !prev[menuKey];
      
//       return newState;
//     });
//   };

//   const isActive = (path) => {
//     return (
//       location.pathname === path ||
//       (path !== "/" && location.pathname.startsWith(path))
//     );
//   };

//   const confirmLogout = async () => {
//     try {
//       await logout();
//       // Clear sidebar mode on logout
//       localStorage.removeItem("sidebarMode");
//       navigate("/");
//     } catch (error) {
//       console.error("Logout failed:", error);
//     } finally {
//       setShowLogoutModal(false);
//     }
//   };

//   // --- Menu Config ---
//   const accountMenuItems = [
//     { name: "Control Panel", path: "/control-panel", icon: <FaSlidersH /> },
//     { name: "Create Account", path: "/createAccount", icon: <FaUserPlus /> },
//     { name: "View Accounts", path: "/viewAccount", icon: <FaUsers /> },
//     { name: "Balance", path: "/balance", icon: <FaMoneyBillAlt /> },
//   ];

//   const leadMenuItems = [
//     { name: "Dashboard", path: "/dashboard", icon: <FaChartBar /> },
//     {
//       name: "Campaigns",
//       path: "/campaigns",
//       icon: <FaRocket />,
//       isDropdown: true,
//       menuKey: "campaigns",
//       subItems: [
//         { name: "Send Single", path: "/sendsingle", icon: <FaEnvelope /> },
//         { name: "Send Bulk", path: "/sendbulk", icon: <FaUsers /> },
//         { name: "Suspended Campaign", path: "/suspended-campaign", icon: <FaPause /> },
//       ]
//     },
//     {
//       name: "DLT Configuration",
//       path: "/dlt-configuration",
//       icon: <FaShieldAlt />,
//       isDropdown: true,
//       menuKey: "dlt-configuration",
//       subItems: [
//         { name: "Senders", path: "/senders", icon: <span className="font-bold">S</span> },
//         { name: "Templates", path: "/templates", icon: <span className="font-bold">T</span> },
//       ]
//     },
//     { name: "User Profile", path: "/userprofile", icon: <FaUserCircle /> },
//     { name: "Reports", path: "/reports", icon: <FaFileInvoice /> },
//     { name: "Settings", path: "/settings", icon: <FaCog /> },
//   ];

//   const currentMenuItems = mode === "account" ? accountMenuItems : leadMenuItems;

//   // --- Render Helper ---
//   const renderMenu = (items, level = 0, parentMenuKey = null) => (
//     <ul className={`space-y-1.5 ${level > 0 ? "ml-4 mt-1 border-l-2 border-gray-100 pl-2" : ""}`}>
//       {items.map((item, index) => {
//         const active = isActive(item.path);
//         const isOpen = openDropdowns[item.menuKey];

//         return (
//           <li key={index}>
//             {item.isDropdown ? (
//               <div className="mb-1">
//                 <button
//                   onClick={() => toggleDropdown(item.menuKey)}
//                   className={`w-full flex items-center justify-between px-4 py-3 rounded-xl text-medium font-semibold transition-all duration-200 group
//                     ${active || isOpen
//                       ? "text-[#012B54] bg-blue-50/50"
//                       : "text-slate-600 hover:bg-slate-50 hover:text-[#012B54]"}`}
//                 >
//                   <div className="flex items-center gap-3">
//                     <span className={`text-lg ${active || isOpen ? "text-[#2372AB]" : "text-slate-400 group-hover:text-[#2372AB]"}`}>
//                       {item.icon}
//                     </span>
//                     <span>{item.name}</span>
//                   </div>
//                   <FaChevronDown
//                     className={`text-xs transition-transform duration-300 ${isOpen ? "rotate-180 text-[#0070ba]" : "text-slate-400"}`}
//                   />
//                 </button>

//                 <AnimatePresence>
//                   {isOpen && (
//                     <motion.div
//                       initial={{ height: 0, opacity: 0 }}
//                       animate={{ height: "auto", opacity: 1 }}
//                       exit={{ height: 0, opacity: 0 }}
//                       className="overflow-hidden"
//                     >
//                       {renderMenu(item.subItems, level + 1, item.menuKey)}
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>
//             ) : (
//               <Link
//                 to={item.path}
//                 onClick={() => {
//                   closeSidebar();
                  
//                   // Update mode based on the link clicked
//                   if (item.path.startsWith("/control-panel") || 
//                       item.path === "/createAccount" ||
//                       item.path === "/viewAccount" ||
//                       item.path === "/balance") {
//                     setMode("account");
//                     localStorage.setItem("sidebarMode", "account");
//                   } else if (item.path.startsWith("/dashboard") ||
//                              item.path.startsWith("/campaigns") ||
//                              item.path.startsWith("/dlt-configuration") ||
//                              item.path.startsWith("/userprofile") ||
//                              item.path.startsWith("/tasks") ||
//                              item.path.startsWith("/settings")) {
//                     setMode("lead");
//                     localStorage.setItem("sidebarMode", "lead");
//                   }
                  
//                   // Only close all dropdowns if clicking a top-level menu item (not a sub-item)
//                   if (level === 0) {
//                     setOpenDropdowns({});
//                   }
//                   // For sub-items, keep the parent dropdown open
//                   // The dropdown will stay open since we don't modify openDropdowns
//                 }}
//                 className={`flex items-center gap-3 px-4 py-3 rounded-xl text-medium font-medium transition-all duration-200 relative group
//                   ${active
//                     ? "bg-[#012B54] text-white shadow-md shadow-blue-900/20"
//                     : "text-slate-600 hover:bg-slate-50 hover:text-[#012B54]"}`}
//               >
//                 <span className={`text-lg z-10 transition-colors ${active ? "text-white" : "text-slate-400 group-hover:text-[#2372AB]"}`}>
//                   {item.icon}
//                 </span>
//                 <span className="z-10">{item.name}</span>
//               </Link>
//             )}
//           </li>
//         );
//       })}
//     </ul>
//   );

//   return (
//     <>
//       <div className="h-full flex flex-col bg-white border-r border-slate-200 shadow-[4px_0_24px_rgba(0,0,0,0.02)] w-full max-w-[280px] relative">

//         {/* Mobile Close Button (Absolute Positioned) */}
//         <button
//           onClick={closeSidebar}
//           className="lg:hidden absolute top-4 right-4 text-slate-400 hover:text-slate-600 z-50 p-2"
//         >
//           <FaTimes size={20} />
//         </button>

//         {/* Navigation Area - Top Padding Added */}
//         <div className="flex-1 overflow-y-auto px-4 custom-scrollbar pt-8">
//           <nav>{renderMenu(currentMenuItems)}</nav>
//         </div>

//         {/* Footer */}
//         <div className="p-4 border-t border-slate-100 bg-slate-50/30">
//           <button
//             onClick={() => setShowLogoutModal(true)}
//             className="flex items-center gap-3 w-full px-4 py-3 text-[18px] font-semibold text-gray-800 hover:text-[#012B54] hover:bg-blue-50 rounded-xl transition-all duration-200 group border border-transparent hover:border-blue-100"
//           >
//             <FaSignOutAlt className="text-lg group-hover:rotate-180 transition-transform duration-500" />
//             <span>Log Out</span>
//           </button>
//         </div>
//       </div>

//       {/* Logout Modal */}
//       {showLogoutModal && (
//         <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
//           <motion.div
//             className="bg-gradient-to-br from-white/50 to-blue-50 p-8 rounded-2xl shadow-2xl w-96 text-center border-white/50"
//             initial={{ scale: 0.9, opacity: 0 }}
//             animate={{ scale: 1, opacity: 1 }}
//             transition={{ duration: 0.3 }}
//           >
//             <div className="w-20 h-20 bg-blue-300/10 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6 border border-blue-500/20 shadow-inner">
//               <FaSignOutAlt className="text-3xl text-[#012B54] drop-shadow-sm" />
//             </div>
//             <p className="text-2xl font-bold text-gray-800 mb-3 bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
//               Confirm Logout
//             </p>
//             <p className="text-gray-800 mb-8 text-lg font-lg">
//               Are you sure you want to log out?
//             </p>
//             <div className="flex justify-center gap-5">
//               <button
//                 onClick={() => setShowLogoutModal(false)}
//                 className="px-8 py-3 border-2 border-gray-400 text-gray-800 rounded-xl font-bold hover:bg-gray-50 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmLogout}
//                 className="px-8 py-3 bg-[#012B54] text-white rounded-xl font-bold hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
//               >
//                 Logout
//               </button>
//             </div>
//           </motion.div>
//         </div>
//       )}
//       <style>{`
//         .custom-scrollbar::-webkit-scrollbar { width: 4px; }
//         .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
//         .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
//       `}</style>
//     </>
//   );
// };

// export default Sidebar;


// import React, { useState, useContext, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { AuthContext } from "../context/AuthContext";
// import {
//   LayoutDashboard,
//   Rocket,
//   ShieldCheck,
//   UserCircle,
//   FileBarChart,
//   Settings,
//   LogOut,
//   Sliders,
//   UserPlus,
//   Users,
//   Wallet,
//   Mail,
//   PauseCircle,
//   ChevronDown,
//   X,
//   Radio,
//   FileText,
//   Send,
//   AlertTriangle
// } from "lucide-react";

// const Sidebar = ({ isOpen, onToggle }) => {
//   const { logout } = useContext(AuthContext);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [openDropdowns, setOpenDropdowns] = useState({});
//   const [mode, setMode] = useState("lead");

//   useEffect(() => {
//     const savedMode = localStorage.getItem("sidebarMode");
    
//     // Check Routes
//     const isAdminRoute = ["/control-panel", "/createAccount", "/viewAccount", "/balance"].some(path => location.pathname.startsWith(path));
//     const isLeadRoute = ["/dashboard", "/campaigns", "/dlt-configuration", "/userprofile", "/tasks", "/settings"].some(path => location.pathname.startsWith(path));

//     if (isAdminRoute) {
//       setMode("account");
//       localStorage.setItem("sidebarMode", "account");
//     } else if (isLeadRoute) {
//       setMode("lead");
//       localStorage.setItem("sidebarMode", "lead");
//     } else if (savedMode) {
//       setMode(savedMode);
//     }

//     // Auto-open dropdowns logic
//     const newOpenDropdowns = {};
//     if (["/sendsingle", "/sendbulk", "/suspended-campaign"].some(p => location.pathname.startsWith(p))) {
//       newOpenDropdowns["campaigns"] = true;
//     }
//     if (["/senders", "/templates"].some(p => location.pathname.startsWith(p))) {
//       newOpenDropdowns["dlt-configuration"] = true;
//     }
//     setOpenDropdowns(prev => ({...prev, ...newOpenDropdowns}));
//   }, [location.pathname]);

//   const closeSidebar = () => {
//     if (window.innerWidth < 1024 && onToggle) {
//       onToggle(false);
//     }
//   };

//   const toggleDropdown = (menuKey) => {
//     setOpenDropdowns((prev) => {
//       // Close all other dropdowns when opening a new one
//       const newState = {};
//       newState[menuKey] = !prev[menuKey];
//       return newState;
//     });
//   };

//   // Logic to determine if a route is active
//   const isActive = (path) => {
//     if (path === "/dashboard" && location.pathname === "/dashboard") return true;
//     if (path !== "/dashboard" && location.pathname.startsWith(path)) return true;
//     return false;
//   };

//   const confirmLogout = async () => {
//     try {
//       await logout();
//       localStorage.removeItem("sidebarMode");
//       navigate("/");
//     } catch (error) {
//       console.error("Logout failed:", error);
//     } finally {
//       setShowLogoutModal(false);
//     }
//   };

//   // --- Configuration ---
//   const accountMenuItems = [
//     { name: "Control Panel", path: "/control-panel", icon: <Sliders size={20} className="text-[#A7A08F]" /> },
//     { name: "Create Account", path: "/createAccount", icon: <UserPlus size={20} className="text-[#A7A08F]" /> },
//     { name: "View Accounts", path: "/viewAccount", icon: <Users size={20} className="text-[#A7A08F]" /> },
//     { name: "Balance", path: "/balance", icon: <Wallet size={20} className="text-[#A7A08F]" /> },
//   ];

//   const leadMenuItems = [
//     { name: "Dashboard", path: "/dashboard", icon: <LayoutDashboard size={20} className="text-[#A7A08F]" /> },
//     {
//       name: "Campaigns", // Changed from "Campaigns"
//       path: "/campaigns",
//       icon: <Rocket size={20} className="text-[#A7A08F]" />,
//       isDropdown: true,
//       menuKey: "campaigns",
//       subItems: [
//         { name: "Send Single", path: "/sendsingle", icon: <Send size={18} className="text-[#A7A08F]" /> },
//         { name: "Send Bulk", path: "/sendbulk", icon: <Mail size={18} className="text-[#A7A08F]" /> },
//         { name: "Suspended Campaign", path: "/suspended-campaign", icon: <PauseCircle size={18} className="text-[#A7A08F]" /> },
//       ]
//     },
//     {
//       name: "DLT Configuration", // Changed from "DLT Config"
//       path: "/dlt-configuration",
//       icon: <ShieldCheck size={20} className="text-[#A7A08F]" />,
//       isDropdown: true,
//       menuKey: "dlt-configuration",
//       subItems: [
//         { name: "Senders", path: "/senders", icon: <Radio size={18} className="text-[#A7A08F]" /> },
//         { name: "Templates", path: "/templates", icon: <FileText size={18} className="text-[#A7A08F]" /> },
//       ]
//     },
//     // { name: "User Profile", path: "/userprofile", icon: <UserCircle size={20} className="text-[#A7A08F]" /> },
//     { name: "Reports", path: "/reports", icon: <FileBarChart size={20} className="text-[#A7A08F]" /> },
//     { name: "Settings", path: "/settings", icon: <Settings size={20} className="text-[#A7A08F]" /> },
//   ];

//   const currentMenuItems = mode === "account" ? accountMenuItems : leadMenuItems;

//   // --- Render Functions ---
  
//   const renderMenu = (items, level = 0) => (
//     <ul className={`space-y-1.5 ${level > 0 ? "mt-2 ml-4 border-l border-[#A7A08F]/10 pl-3" : "mt-6"}`}>
//       {items.map((item, index) => {
//         const active = isActive(item.path);
//         const isOpen = openDropdowns[item.menuKey];
        
//         const itemBaseClass = `
//           relative flex items-center justify-between w-full px-4 py-3 rounded-md
//           transition-all duration-200 ease-in-out cursor-pointer text-sm font-medium
//           outline-none focus:outline-none ring-0
//         `;
        
//         const activeClass = "bg-[#C5F637]/10 text-[#C5F637]"; 
//         const inactiveClass = "text-white hover:bg-white/5 hover:text-white";

//         return (
//           <li key={index}>
//             {item.isDropdown ? (
//               <div>
//                 <button
//                   onClick={() => toggleDropdown(item.menuKey)}
//                   className={`${itemBaseClass} ${active || isOpen ? activeClass : inactiveClass}`}
//                 >
//                   <div className="flex items-center gap-3">
//                     <span className={`transition-transform duration-300 ${active || isOpen ? "scale-105" : ""}`}>
//                       {item.icon}
//                     </span>
//                     <span className="tracking-wide">{item.name}</span>
//                   </div>
//                   <ChevronDown
//                     size={16}
//                     className={`text-[#A7A08F] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
//                   />
//                 </button>

//                 <AnimatePresence>
//                   {isOpen && (
//                     <motion.div
//                       initial={{ height: 0, opacity: 0 }}
//                       animate={{ height: "auto", opacity: 1 }}
//                       exit={{ height: 0, opacity: 0 }}
//                       className="overflow-hidden"
//                     >
//                       {renderMenu(item.subItems, level + 1)}
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>
//             ) : (
//               <Link
//                 to={item.path}
//                 onClick={() => {
//                   closeSidebar();
//                   if (document.activeElement instanceof HTMLElement) {
//                     document.activeElement.blur();
//                   }
//                 }}
//                 className={`${itemBaseClass} ${active ? activeClass : inactiveClass}`}
//               >
//                 <div className="flex items-center gap-3">
//                    <span className={`transition-transform duration-300 ${active ? "scale-105" : ""}`}>
//                     {item.icon}
//                   </span>
//                   <span className="tracking-wide">{item.name}</span>
//                 </div>
                
//                 {active && (
//                    <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-[#C5F637] rounded-r-md opacity-80" />
//                 )}
//               </Link>
//             )}
//           </li>
//         );
//       })}
//     </ul>
//   );

//   return (
//     <>
//       {/* Sidebar Container */}
//       <div 
//         className="h-full flex flex-col relative z-40 w-full max-w-[280px] shadow-2xl transition-all duration-300"
//         style={{ backgroundColor: '#0C4550' }}
//       >
//         <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-transparent pointer-events-none" />

//         {/* Mobile Close */}
//         <button
//           onClick={closeSidebar}
//           className="lg:hidden absolute top-4 right-4 text-[#A7A08F] hover:text-[#C5F637] transition-colors z-50 p-2 outline-none"
//         >
//           <X size={24} />
//         </button>

//         {/* Branding */}
//         <div className="pt-10 px-6 pb-4 relative z-10">
//             <h1 className="text-3xl font-extrabold text-white tracking-tight flex items-baseline">
//                 EURO<span className="text-[#C5F637]">FOX</span>
//                 <span className="w-2 h-2 rounded-full bg-[#C5F637] ml-1 mb-1 animate-pulse"></span>
//             </h1>
//             <p className="text-[#A7A08F] text-[10px] uppercase tracking-[0.2em] mt-1 font-semibold pl-0.5">
//                 Bulk SMS Portal
//             </p>
//         </div>

//         {/* Navigation */}
//         <div className="flex-1 overflow-y-auto px-4 custom-scrollbar relative z-10">
//           <nav>{renderMenu(currentMenuItems)}</nav>
//         </div>

//         {/* Footer with Logout Button */}
//         <div className="p-4 border-t border-[#A7A08F]/20 relative z-10">
//           <button
//             onClick={() => setShowLogoutModal(true)}
//             className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-white hover:text-white hover:bg-white/5 transition-all duration-200 font-medium outline-none focus:outline-none"
//           >
//             <LogOut size={20} className="text-[#A7A08F]" />
//             <span className="text-sm">Log Out</span>
//           </button>
//         </div>
//       </div>
// {/* Updated Logout Modal */}
// <AnimatePresence>
//   {showLogoutModal && (
//     <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
//       {/* Backdrop */}
//       <motion.div 
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//         className="absolute inset-0 bg-black/50 backdrop-blur-sm"
//         onClick={() => setShowLogoutModal(false)}
//       />

//       {/* Modal Content */}
//       <motion.div
//         className="relative bg-[#0C4550] rounded-xl shadow-2xl w-full max-w-sm overflow-hidden border border-[#C5F637]/20"
//         initial={{ scale: 0.95, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         exit={{ scale: 0.95, opacity: 0 }}
//         transition={{ duration: 0.2 }}
//       >
//         {/* Modal Body */}
//         <div className="p-6 text-center">
          
//           {/* Icon with animation */}
//           <motion.div 
//             className="w-16 h-16 bg-[#C5F637]/10 rounded-full flex items-center justify-center mx-auto mb-5 border border-[#C5F637]/20"
//             initial={{ scale: 0, rotate: -180 }}
//             animate={{ scale: 1, rotate: 0 }}
//             transition={{ type: "spring", stiffness: 200, damping: 15 }}
//           >
//             <LogOut className="text-2xl text-[#C5F637]" />
//           </motion.div>
          
//           {/* Title */}
//           <motion.p 
//             className="text-xl font-bold text-white mb-2"
//             initial={{ y: 10, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ delay: 0.1 }}
//           >
//             Confirm Logout
//           </motion.p>
          
//           {/* Message */}
//           <motion.p 
//             className="text-[#A7A08F] mb-6"
//             initial={{ y: 10, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ delay: 0.15 }}
//           >
//             Are you sure you want to log out?
//           </motion.p>
          
//           {/* Buttons */}
//           <div className="flex gap-3">
//             {/* Cancel Button */}
//             <motion.button
//               onClick={() => setShowLogoutModal(false)}
//               className="flex-1 px-4 py-3 bg-[#1A5A66] text-white rounded-lg font-medium"
//               initial={{ x: -20, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               transition={{ delay: 0.2, type: "spring", stiffness: 300 }}
//               whileHover={{ 
//                 scale: 1.05,
//                 backgroundColor: "#1E6470",
//                 transition: { type: "spring", stiffness: 400 }
//               }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="flex items-center justify-center gap-2">
//                 <motion.svg 
//                   className="w-4 h-4"
//                   initial={{ x: -5, opacity: 0 }}
//                   animate={{ x: 0, opacity: 1 }}
//                   transition={{ delay: 0.25 }}
//                 >
//                   <path 
//                     fill="currentColor" 
//                     d="M6.707 4.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6z"
//                   />
//                 </motion.svg>
//                 Cancel
//               </span>
//             </motion.button>
            
//             {/* Logout Button */}
//             <motion.button
//               onClick={confirmLogout}
//               className="flex-1 px-4 py-3 bg-gradient-to-r from-[#C5F637] to-[#D0FF4A] text-[#0C4550] rounded-lg font-bold"
//               initial={{ x: 20, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               transition={{ delay: 0.2, type: "spring", stiffness: 300 }}
//               whileHover={{ 
//                 scale: 1.05,
//                 boxShadow: "0 0 15px rgba(197, 246, 55, 0.3)",
//                 transition: { type: "spring", stiffness: 400 }
//               }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="flex items-center justify-center gap-2">
//                 Logout
//                 <motion.span
//                   initial={{ x: 5, opacity: 0 }}
//                   animate={{ x: 0, opacity: 1 }}
//                   transition={{ delay: 0.25 }}
//                   whileHover={{ x: 3 }}
//                 >
//                   <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
//                   </svg>
//                 </motion.span>
//               </span>
//             </motion.button>
//           </div>
//         </div>
        
//         {/* Decorative elements */}
//         <motion.div 
//           className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-[#C5F637]/0 via-[#C5F637]/20 to-[#C5F637]/0"
//           initial={{ scaleY: 0 }}
//           animate={{ scaleY: 1 }}
//           transition={{ duration: 0.5, delay: 0.3 }}
//         />
//         <motion.div 
//           className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-[#C5F637]/0 via-[#C5F637]/20 to-[#C5F637]/0"
//           initial={{ scaleY: 0 }}
//           animate={{ scaleY: 1 }}
//           transition={{ duration: 0.5, delay: 0.4 }}
//         />
//       </motion.div>
//     </div>
//   )}
// </AnimatePresence>

//       <style>{`
//         .custom-scrollbar::-webkit-scrollbar { width: 4px; }
//         .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
//         .custom-scrollbar::-webkit-scrollbar-thumb { background: #A7A08F; border-radius: 10px; opacity: 0.2; }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #C5F637; }
//       `}</style>
//     </>
//   );
// };

// export default Sidebar;





// import React, { useState, useContext, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { AuthContext } from "../context/AuthContext";
// import {
//   LayoutDashboard,
//   Rocket,
//   ShieldCheck,
//   UserCircle,
//   FileBarChart,
//   Settings,
//   LogOut,
//   Sliders,
//   UserPlus,
//   Users,
//   Wallet,
//   Mail,
//   PauseCircle,
//   ChevronDown,
//   X,
//   Radio,
//   FileText,
//   Send,
//   AlertTriangle
// } from "lucide-react";

// // --- JWT Helper to get Role ---
// const parseJwt = (token) => {
//   try {
//     if (!token) return null;
//     const base64Url = token.split('.')[1];
//     const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//     const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
//         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//     }).join(''));
//     return JSON.parse(jsonPayload);
//   } catch (e) {
//     return null;
//   }
// };

// const Sidebar = ({ isOpen, onToggle }) => {
//   const { logout } = useContext(AuthContext);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const [openDropdowns, setOpenDropdowns] = useState({});
//   const [mode, setMode] = useState("lead");
  
//   // --- State for User Role ---
//   const [userRole, setUserRole] = useState("");

//   useEffect(() => {
//     // Fetch and parse role from token
//     const token = localStorage.getItem("token");
//     if (token) {
//       const decoded = parseJwt(token);
//       // Assuming the key in your JWT is 'role' or 'accountType'. Adjust if necessary.
//       const role = decoded?.role || decoded?.accountType || ""; 
//       setUserRole(role);
//     }

//     const savedMode = localStorage.getItem("sidebarMode");
    
//     // Check Routes
//     const isAdminRoute = ["/control-panel", "/createAccount", "/viewAccount", "/balance"].some(path => location.pathname.startsWith(path));
//     const isLeadRoute = ["/dashboard", "/campaigns", "/dlt-configuration", "/userprofile", "/tasks", "/settings"].some(path => location.pathname.startsWith(path));

//     if (isAdminRoute) {
//       setMode("account");
//       localStorage.setItem("sidebarMode", "account");
//     } else if (isLeadRoute) {
//       setMode("lead");
//       localStorage.setItem("sidebarMode", "lead");
//     } else if (savedMode) {
//       setMode(savedMode);
//     }

//     // Auto-open dropdowns logic
//     const newOpenDropdowns = {};
//     if (["/sendsingle", "/sendbulk", "/suspended-campaign"].some(p => location.pathname.startsWith(p))) {
//       newOpenDropdowns["campaigns"] = true;
//     }
//     if (["/senders", "/templates"].some(p => location.pathname.startsWith(p))) {
//       newOpenDropdowns["dlt-configuration"] = true;
//     }
//     setOpenDropdowns(prev => ({...prev, ...newOpenDropdowns}));
//   }, [location.pathname]);

//   const closeSidebar = () => {
//     if (window.innerWidth < 1024 && onToggle) {
//       onToggle(false);
//     }
//   };

//   const toggleDropdown = (menuKey) => {
//     setOpenDropdowns((prev) => {
//       // Close all other dropdowns when opening a new one
//       const newState = {};
//       newState[menuKey] = !prev[menuKey];
//       return newState;
//     });
//   };

//   // Logic to determine if a route is active
//   const isActive = (path) => {
//     if (path === "/dashboard" && location.pathname === "/dashboard") return true;
//     if (path !== "/dashboard" && location.pathname.startsWith(path)) return true;
//     return false;
//   };

//   const confirmLogout = async () => {
//     try {
//       await logout();
//       localStorage.removeItem("sidebarMode");
//       navigate("/");
//     } catch (error) {
//       console.error("Logout failed:", error);
//     } finally {
//       setShowLogoutModal(false);
//     }
//   };

//   // --- Configuration ---
//   const accountMenuItems = [
//     { name: "Control Panel", path: "/control-panel", icon: <Sliders size={20} className="text-[#A7A08F]" /> },
//     { name: "Create Account", path: "/createAccount", icon: <UserPlus size={20} className="text-[#A7A08F]" /> },
//     { name: "View Accounts", path: "/viewAccount", icon: <Users size={20} className="text-[#A7A08F]" /> },
//     { name: "Balance", path: "/balance", icon: <Wallet size={20} className="text-[#A7A08F]" /> },
//   ];

//   const leadMenuItems = [
//     { name: "Dashboard", path: "/dashboard", icon: <LayoutDashboard size={20} className="text-[#A7A08F]" /> },
//     {
//       name: "Campaigns",
//       path: "/campaigns",
//       icon: <Rocket size={20} className="text-[#A7A08F]" />,
//       isDropdown: true,
//       menuKey: "campaigns",
//       subItems: [
//         { name: "Send Single", path: "/sendsingle", icon: <Send size={18} className="text-[#A7A08F]" /> },
//         { name: "Send Bulk", path: "/sendbulk", icon: <Mail size={18} className="text-[#A7A08F]" /> },
//         { name: "Suspended Campaign", path: "/suspended-campaign", icon: <PauseCircle size={18} className="text-[#A7A08F]" /> },
//       ]
//     },
//     {
//       name: "DLT Configuration",
//       path: "/dlt-configuration",
//       icon: <ShieldCheck size={20} className="text-[#A7A08F]" />,
//       isDropdown: true,
//       menuKey: "dlt-configuration",
//       subItems: [
//         { name: "Senders", path: "/senders", icon: <Radio size={18} className="text-[#A7A08F]" /> },
//         { name: "Templates", path: "/templates", icon: <FileText size={18} className="text-[#A7A08F]" /> },
//       ]
//     },
//     // { name: "User Profile", path: "/userprofile", icon: <UserCircle size={20} className="text-[#A7A08F]" /> },
//     { name: "Reports", path: "/reports", icon: <FileBarChart size={20} className="text-[#A7A08F]" /> },
//     { name: "Settings", path: "/settings", icon: <Settings size={20} className="text-[#A7A08F]" /> },
//   ];

//   // --- Logic to Filter Account Menu Items based on Role ---
//   let filteredAccountMenuItems = [];

//   if (userRole === "SUPER_SUPER_ADMIN") {
//     // Super Super Admin sees everything
//     filteredAccountMenuItems = accountMenuItems;
//   } else if (userRole === "SUPER_ADMIN" || userRole === "RESELLER") {
//     // Super Admin & Reseller see only Create Account and View Accounts
//     filteredAccountMenuItems = accountMenuItems.filter(item => 
//       ["Create Account", "View Accounts"].includes(item.name)
//     );
//   } else {
//     // Company or others (should not normally see this, but safe fallback)
//     filteredAccountMenuItems = [];
//   }

//   // Assign menu items based on mode
//   const currentMenuItems = mode === "account" ? filteredAccountMenuItems : leadMenuItems;

//   // --- Render Functions ---
  
//   const renderMenu = (items, level = 0) => (
//     <ul className={`space-y-1.5 ${level > 0 ? "mt-2 ml-4 border-l border-[#A7A08F]/10 pl-3" : "mt-6"}`}>
//       {items.map((item, index) => {
//         const active = isActive(item.path);
//         const isOpen = openDropdowns[item.menuKey];
        
//         const itemBaseClass = `
//           relative flex items-center justify-between w-full px-4 py-3 rounded-md
//           transition-all duration-200 ease-in-out cursor-pointer text-sm font-medium
//           outline-none focus:outline-none ring-0
//         `;
        
//         const activeClass = "bg-[#C5F637]/10 text-[#C5F637]"; 
//         const inactiveClass = "text-white hover:bg-white/5 hover:text-white";

//         return (
//           <li key={index}>
//             {item.isDropdown ? (
//               <div>
//                 <button
//                   onClick={() => toggleDropdown(item.menuKey)}
//                   className={`${itemBaseClass} ${active || isOpen ? activeClass : inactiveClass}`}
//                 >
//                   <div className="flex items-center gap-3">
//                     <span className={`transition-transform duration-300 ${active || isOpen ? "scale-105" : ""}`}>
//                       {item.icon}
//                     </span>
//                     <span className="tracking-wide">{item.name}</span>
//                   </div>
//                   <ChevronDown
//                     size={16}
//                     className={`text-[#A7A08F] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
//                   />
//                 </button>

//                 <AnimatePresence>
//                   {isOpen && (
//                     <motion.div
//                       initial={{ height: 0, opacity: 0 }}
//                       animate={{ height: "auto", opacity: 1 }}
//                       exit={{ height: 0, opacity: 0 }}
//                       className="overflow-hidden"
//                     >
//                       {renderMenu(item.subItems, level + 1)}
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>
//             ) : (
//               <Link
//                 to={item.path}
//                 onClick={() => {
//                   closeSidebar();
//                   if (document.activeElement instanceof HTMLElement) {
//                     document.activeElement.blur();
//                   }
//                 }}
//                 className={`${itemBaseClass} ${active ? activeClass : inactiveClass}`}
//               >
//                 <div className="flex items-center gap-3">
//                    <span className={`transition-transform duration-300 ${active ? "scale-105" : ""}`}>
//                     {item.icon}
//                   </span>
//                   <span className="tracking-wide">{item.name}</span>
//                 </div>
                
//                 {active && (
//                    <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-[#C5F637] rounded-r-md opacity-80" />
//                 )}
//               </Link>
//             )}
//           </li>
//         );
//       })}
//     </ul>
//   );

//   return (
//     <>
//       {/* Sidebar Container */}
//       <div 
//         className="h-full flex flex-col relative z-40 w-full max-w-[280px] shadow-2xl transition-all duration-300"
//         style={{ backgroundColor: '#0C4550' }}
//       >
//         <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-transparent pointer-events-none" />

//         {/* Mobile Close */}
//         <button
//           onClick={closeSidebar}
//           className="lg:hidden absolute top-4 right-4 text-[#A7A08F] hover:text-[#C5F637] transition-colors z-50 p-2 outline-none"
//         >
//           <X size={24} />
//         </button>

//         {/* Branding */}
//         <div className="pt-10 px-6 pb-4 relative z-10">
//             <h1 className="text-3xl font-extrabold text-white tracking-tight flex items-baseline">
//                 EURO<span className="text-[#C5F637]">FOX</span>
//                 <span className="w-2 h-2 rounded-full bg-[#C5F637] ml-1 mb-1 animate-pulse"></span>
//             </h1>
//             <p className="text-[#A7A08F] text-[10px] uppercase tracking-[0.2em] mt-1 font-semibold pl-0.5">
//                 Bulk SMS Portal
//             </p>
//         </div>

//         {/* Navigation */}
//         <div className="flex-1 overflow-y-auto px-4 custom-scrollbar relative z-10">
//           <nav>{renderMenu(currentMenuItems)}</nav>
//         </div>

//         {/* Footer with Logout Button */}
//         <div className="p-4 border-t border-[#A7A08F]/20 relative z-10">
//           <button
//             onClick={() => setShowLogoutModal(true)}
//             className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-white hover:text-white hover:bg-white/5 transition-all duration-200 font-medium outline-none focus:outline-none"
//           >
//             <LogOut size={20} className="text-[#A7A08F]" />
//             <span className="text-sm">Log Out</span>
//           </button>
//         </div>
//       </div>
// {/* Updated Logout Modal */}
// <AnimatePresence>
//   {showLogoutModal && (
//     <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
//       {/* Backdrop */}
//       <motion.div 
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//         className="absolute inset-0 bg-black/50 backdrop-blur-sm"
//         onClick={() => setShowLogoutModal(false)}
//       />

//       {/* Modal Content */}
//       <motion.div
//         className="relative bg-[#0C4550] rounded-xl shadow-2xl w-full max-w-sm overflow-hidden border border-[#C5F637]/20"
//         initial={{ scale: 0.95, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         exit={{ scale: 0.95, opacity: 0 }}
//         transition={{ duration: 0.2 }}
//       >
//         {/* Modal Body */}
//         <div className="p-6 text-center">
          
//           {/* Icon with animation */}
//           <motion.div 
//             className="w-16 h-16 bg-[#C5F637]/10 rounded-full flex items-center justify-center mx-auto mb-5 border border-[#C5F637]/20"
//             initial={{ scale: 0, rotate: -180 }}
//             animate={{ scale: 1, rotate: 0 }}
//             transition={{ type: "spring", stiffness: 200, damping: 15 }}
//           >
//             <LogOut className="text-2xl text-[#C5F637]" />
//           </motion.div>
          
//           {/* Title */}
//           <motion.p 
//             className="text-xl font-bold text-white mb-2"
//             initial={{ y: 10, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ delay: 0.1 }}
//           >
//             Confirm Logout
//           </motion.p>
          
//           {/* Message */}
//           <motion.p 
//             className="text-[#A7A08F] mb-6"
//             initial={{ y: 10, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ delay: 0.15 }}
//           >
//             Are you sure you want to log out?
//           </motion.p>
          
//           {/* Buttons */}
//           <div className="flex gap-3">
//             {/* Cancel Button */}
//             <motion.button
//               onClick={() => setShowLogoutModal(false)}
//               className="flex-1 px-4 py-3 bg-[#1A5A66] text-white rounded-lg font-medium"
//               initial={{ x: -20, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               transition={{ delay: 0.2, type: "spring", stiffness: 300 }}
//               whileHover={{ 
//                 scale: 1.05,
//                 backgroundColor: "#1E6470",
//                 transition: { type: "spring", stiffness: 400 }
//               }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="flex items-center justify-center gap-2">
//                 <motion.svg 
//                   className="w-4 h-4"
//                   initial={{ x: -5, opacity: 0 }}
//                   animate={{ x: 0, opacity: 1 }}
//                   transition={{ delay: 0.25 }}
//                 >
//                   <path 
//                     fill="currentColor" 
//                     d="M6.707 4.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6z"
//                   />
//                 </motion.svg>
//                 Cancel
//               </span>
//             </motion.button>
            
//             {/* Logout Button */}
//             <motion.button
//               onClick={confirmLogout}
//               className="flex-1 px-4 py-3 bg-gradient-to-r from-[#C5F637] to-[#D0FF4A] text-[#0C4550] rounded-lg font-bold"
//               initial={{ x: 20, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               transition={{ delay: 0.2, type: "spring", stiffness: 300 }}
//               whileHover={{ 
//                 scale: 1.05,
//                 boxShadow: "0 0 15px rgba(197, 246, 55, 0.3)",
//                 transition: { type: "spring", stiffness: 400 }
//               }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <span className="flex items-center justify-center gap-2">
//                 Logout
//                 <motion.span
//                   initial={{ x: 5, opacity: 0 }}
//                   animate={{ x: 0, opacity: 1 }}
//                   transition={{ delay: 0.25 }}
//                   whileHover={{ x: 3 }}
//                 >
//                   <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
//                   </svg>
//                 </motion.span>
//               </span>
//             </motion.button>
//           </div>
//         </div>
        
//         {/* Decorative elements */}
//         <motion.div 
//           className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-[#C5F637]/0 via-[#C5F637]/20 to-[#C5F637]/0"
//           initial={{ scaleY: 0 }}
//           animate={{ scaleY: 1 }}
//           transition={{ duration: 0.5, delay: 0.3 }}
//         />
//         <motion.div 
//           className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-[#C5F637]/0 via-[#C5F637]/20 to-[#C5F637]/0"
//           initial={{ scaleY: 0 }}
//           animate={{ scaleY: 1 }}
//           transition={{ duration: 0.5, delay: 0.4 }}
//         />
//       </motion.div>
//     </div>
//   )}
// </AnimatePresence>

//       <style>{`
//         .custom-scrollbar::-webkit-scrollbar { width: 4px; }
//         .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
//         .custom-scrollbar::-webkit-scrollbar-thumb { background: #A7A08F; border-radius: 10px; opacity: 0.2; }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #C5F637; }
//       `}</style>
//     </>
//   );
// };

// export default Sidebar;






import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { AuthContext } from "../context/AuthContext";
import {
  LayoutDashboard,
  Rocket,
  ShieldCheck,
  UserCircle,
  FileBarChart,
  Settings,
  LogOut,
  Sliders,
  UserPlus,
  Users,
  Wallet,
  Mail,
  PauseCircle,
  ChevronDown,
  X,
  Radio,
  FileText,
  Send,
  AlertTriangle,
  MessageSquare, // Professional icon for Queries
  Target,
  FilterX
} from "lucide-react";

// --- JWT Helper to get Role ---
const parseJwt = (token) => {
  try {
    if (!token) return null;
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

const Sidebar = ({ isOpen, onToggle }) => {
  const { logout } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [mode, setMode] = useState("lead");
  
  // --- State for User Role ---
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    // Fetch and parse role from token
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = parseJwt(token);
      const role = decoded?.role || decoded?.accountType || ""; 
      setUserRole(role);
    }

    const savedMode = localStorage.getItem("sidebarMode");
    
    // Check Routes
    const isAdminRoute = ["/control-panel", "/createAccount", "/viewAccount", "/balance", "/queries"].some(path => location.pathname.startsWith(path));
    const isLeadRoute = ["/dashboard", "/contacts", "/campaigns", "/dlt-configuration", "/userprofile", "/tasks", "/settings"].some(path => location.pathname.startsWith(path));

    if (isAdminRoute) {
      setMode("account");
      localStorage.setItem("sidebarMode", "account");
    } else if (isLeadRoute) {
      setMode("lead");
      localStorage.setItem("sidebarMode", "lead");
    } else if (savedMode) {
      setMode(savedMode);
    }

    // Auto-open dropdowns logic
    const newOpenDropdowns = {};
    if (["/sendsingle", "/sendbulk" ].some(p => location.pathname.startsWith(p))) {
      newOpenDropdowns["campaigns"] = true;
    }
    if (["/senders", "/templates"].some(p => location.pathname.startsWith(p))) {
      newOpenDropdowns["dlt-configuration"] = true;
    }
    setOpenDropdowns(prev => ({...prev, ...newOpenDropdowns}));
  }, [location.pathname]);

  const closeSidebar = () => {
    if (window.innerWidth < 1024 && onToggle) {
      onToggle(false);
    }
  };

  const toggleDropdown = (menuKey) => {
    setOpenDropdowns((prev) => {
      const newState = {};
      newState[menuKey] = !prev[menuKey];
      return newState;
    });
  };

  const isActive = (path) => {
    if (path === "/dashboard" && location.pathname === "/dashboard") return true;
    if (path !== "/dashboard" && location.pathname.startsWith(path)) return true;
    return false;
  };

  const confirmLogout = async () => {
    try {
      await logout();
      localStorage.removeItem("sidebarMode");
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setShowLogoutModal(false);
    }
  };

  // --- Configuration ---
  const accountMenuItems = [
    { name: "Control Panel", path: "/control-panel", icon: <Sliders size={20} className="text-[#A7A08F]" /> },
    { name: "Create Account", path: "/createAccount", icon: <UserPlus size={20} className="text-[#A7A08F]" /> },
    { name: "View Accounts", path: "/viewAccount", icon: <Users size={20} className="text-[#A7A08F]" /> },
    { name: "Balance", path: "/balance", icon: <Wallet size={20} className="text-[#A7A08F]" /> },
    { name: "Queries", path: "/queries", icon: <MessageSquare size={20} className="text-[#A7A08F]" /> },
  ];

  const leadMenuItems = [
    { name: "Dashboard", path: "/dashboard", icon: <LayoutDashboard size={20} className="text-[#A7A08F]" /> },
    { name: "Contacts", path: "/contacts", icon: <Users size={20}  className="text-[#A7A08F]" /> },
    {
      name: "Campaigns",
      path: "/campaigns",
      icon: <Rocket size={20} className="text-[#A7A08F]" />,
      isDropdown: true,
      menuKey: "campaigns",
      subItems: [
        { name: "Send Single", path: "/sendsingle", icon: <Send size={18} className="text-[#A7A08F]" /> },
        { name: "Send Bulk", path: "/sendbulk", icon: <Mail size={18} className="text-[#A7A08F]" /> },
        // { name: "Suspended Campaign", path: "/suspended-campaign", icon: <PauseCircle size={18} className="text-[#A7A08F]" /> },
      ]
    },
    {
      name: "DLT Configuration",
      path: "/dlt-configuration",
      icon: <ShieldCheck size={20} className="text-[#A7A08F]" />,
      isDropdown: true,
      menuKey: "dlt-configuration",
      subItems: [
        { name: "Senders", path: "/senders", icon: <Radio size={18} className="text-[#A7A08F]" /> },
        { name: "Templates", path: "/templates", icon: <FileText size={18} className="text-[#A7A08F]" /> },
      ]
    },
    { name: "Reports", path: "/reports", icon: <FileBarChart size={20} className="text-[#A7A08F]" /> },
    { name: "DND Filter", path: "/dnd-filter", icon: <FilterX size={20} className="text-[#A7A08F]" /> },
    { name: "Generate Leads", path: "/generate-leads", icon: <Target size={20}  className="text-[#A7A08F]" /> },
    { name: "Settings", path: "/settings", icon: <Settings size={20} className="text-[#A7A08F]" /> },

  ];

  // --- Logic to Filter Account Menu Items based on Role ---
  let filteredAccountMenuItems = [];

  if (userRole === "SUPER_SUPER_ADMIN") {
    // Super Super Admin sees everything including Queries
    filteredAccountMenuItems = accountMenuItems;
  } else if (userRole === "SUPER_ADMIN" || userRole === "RESELLER") {
    // Super Admin & Reseller see only Create Account and View Accounts
    // Queries is automatically excluded here
    filteredAccountMenuItems = accountMenuItems.filter(item => 
      ["Create Account", "View Accounts"].includes(item.name)
    );
  } else {
    filteredAccountMenuItems = [];
  }

  const currentMenuItems = mode === "account" ? filteredAccountMenuItems : leadMenuItems;

  const renderMenu = (items, level = 0) => (
    <ul className={`space-y-1.5 ${level > 0 ? "mt-2 ml-4 border-l border-[#A7A08F]/10 pl-3" : "mt-6"}`}>
      {items.map((item, index) => {
        const active = isActive(item.path);
        const isOpen = openDropdowns[item.menuKey];
        
        const itemBaseClass = `
          relative flex items-center justify-between w-full px-4 py-3 rounded-md
          transition-all duration-200 ease-in-out cursor-pointer text-sm font-medium
          outline-none focus:outline-none ring-0
        `;
        
        const activeClass = "bg-[#C5F637]/10 text-[#C5F637]"; 
        const inactiveClass = "text-white hover:bg-white/5 hover:text-white";

        return (
          <li key={index}>
            {item.isDropdown ? (
              <div>
                <button
                  onClick={() => toggleDropdown(item.menuKey)}
                  className={`${itemBaseClass} ${active || isOpen ? activeClass : inactiveClass}`}
                >
                  <div className="flex items-center gap-3">
                    <span className={`transition-transform duration-300 ${active || isOpen ? "scale-105" : ""}`}>
                      {item.icon}
                    </span>
                    <span className="tracking-wide">{item.name}</span>
                  </div>
                  <ChevronDown
                    size={16}
                    className={`text-[#A7A08F] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>

                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden"
                    >
                      {renderMenu(item.subItems, level + 1)}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ) : (
              <Link
                to={item.path}
                onClick={() => {
                  closeSidebar();
                  if (document.activeElement instanceof HTMLElement) {
                    document.activeElement.blur();
                  }
                }}
                className={`${itemBaseClass} ${active ? activeClass : inactiveClass}`}
              >
                <div className="flex items-center gap-3">
                   <span className={`transition-transform duration-300 ${active ? "scale-105" : ""}`}>
                    {item.icon}
                  </span>
                  <span className="tracking-wide">{item.name}</span>
                </div>
                
                {active && (
                   <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-[#C5F637] rounded-r-md opacity-80" />
                )}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      <div 
        className="h-full flex flex-col relative z-40 w-full max-w-[280px] shadow-2xl transition-all duration-300"
        style={{ backgroundColor: '#0C4550' }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-transparent pointer-events-none" />

        <button
          onClick={closeSidebar}
          className="lg:hidden absolute top-4 right-4 text-[#A7A08F] hover:text-[#C5F637] transition-colors z-50 p-2 outline-none"
        >
          <X size={24} />
        </button>

        <div className="pt-10 px-6 pb-4 relative z-10">
            <h1 className="text-3xl font-extrabold text-white tracking-tight flex items-baseline">
                EURO<span className="text-[#C5F637]">FOX</span>
                <span className="w-2 h-2 rounded-full bg-[#C5F637] ml-1 mb-1 animate-pulse"></span>
            </h1>
            <p className="text-[#A7A08F] text-[10px] uppercase tracking-[0.2em] mt-1 font-semibold pl-0.5">
                Bulk SMS Portal
            </p>
        </div>

        <div className="flex-1 overflow-y-auto px-4 custom-scrollbar relative z-10">
          <nav>{renderMenu(currentMenuItems)}</nav>
        </div>

        <div className="p-4 border-t border-[#A7A08F]/20 relative z-10">
          <button
            onClick={() => setShowLogoutModal(true)}
            className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-white hover:text-white hover:bg-white/5 transition-all duration-200 font-medium outline-none focus:outline-none"
          >
            <LogOut size={20} className="text-[#A7A08F]" />
            <span className="text-sm">Log Out</span>
          </button>
        </div>
      </div>

      <AnimatePresence>
        {showLogoutModal && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="absolute inset-0 bg-black/50 backdrop-blur-sm"
              onClick={() => setShowLogoutModal(false)}
            />

            <motion.div
              className="relative bg-[#0C4550] rounded-xl shadow-2xl w-full max-w-sm overflow-hidden border border-[#C5F637]/20"
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div className="p-6 text-center">
                <motion.div 
                  className="w-16 h-16 bg-[#C5F637]/10 rounded-full flex items-center justify-center mx-auto mb-5 border border-[#C5F637]/20"
                  initial={{ scale: 0, rotate: -180 }}
                  animate={{ scale: 1, rotate: 0 }}
                  transition={{ type: "spring", stiffness: 200, damping: 15 }}
                >
                  <LogOut className="text-2xl text-[#C5F637]" />
                </motion.div>
                
                <motion.p 
                  className="text-xl font-bold text-white mb-2"
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.1 }}
                >
                  Confirm Logout
                </motion.p>
                
                <motion.p 
                  className="text-[#A7A08F] mb-6"
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.15 }}
                >
                  Are you sure you want to log out?
                </motion.p>
                
                <div className="flex gap-3">
                  <motion.button
                    onClick={() => setShowLogoutModal(false)}
                    className="flex-1 px-4 py-3 bg-[#1A5A66] text-white rounded-lg font-medium"
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.2, type: "spring", stiffness: 300 }}
                    whileHover={{ 
                      scale: 1.05,
                      backgroundColor: "#1E6470",
                      transition: { type: "spring", stiffness: 400 }
                    }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <span className="flex items-center justify-center gap-2">
                      <motion.svg 
                        className="w-4 h-4"
                        initial={{ x: -5, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.25 }}
                      >
                        <path 
                          fill="currentColor" 
                          d="M6.707 4.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6z"
                        />
                      </motion.svg>
                      Cancel
                    </span>
                  </motion.button>
                  
                  <motion.button
                    onClick={confirmLogout}
                    className="flex-1 px-4 py-3 bg-gradient-to-r from-[#C5F637] to-[#D0FF4A] text-[#0C4550] rounded-lg font-bold"
                    initial={{ x: 20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.2, type: "spring", stiffness: 300 }}
                    whileHover={{ 
                      scale: 1.05,
                      boxShadow: "0 0 15px rgba(197, 246, 55, 0.3)",
                      transition: { type: "spring", stiffness: 400 }
                    }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <span className="flex items-center justify-center gap-2">
                      Logout
                      <motion.span
                        initial={{ x: 5, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.25 }}
                        whileHover={{ x: 3 }}
                      >
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                      </motion.span>
                    </span>
                  </motion.button>
                </div>
              </div>
              
              <motion.div 
                className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-[#C5F637]/0 via-[#C5F637]/20 to-[#C5F637]/0"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 1 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              />
              <motion.div 
                className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-[#C5F637]/0 via-[#C5F637]/20 to-[#C5F637]/0"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 1 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              />
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #A7A08F; border-radius: 10px; opacity: 0.2; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #C5F637; }
      `}</style>
    </>
  );
};

export default Sidebar;